import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/site-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-7fade5e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gnav" }
const _hoisted_2 = { class: "gnav__logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "gnav-menu" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<a href=\"#\" data-v-7fade5e0><div class=\"gnav-menu__bar gnav-menu__bar--1-1\" data-v-7fade5e0></div><div class=\"gnav-menu__bar gnav-menu__bar--1-2\" data-v-7fade5e0></div><div class=\"gnav-menu__bar gnav-menu__bar--2-1\" data-v-7fade5e0></div><div class=\"gnav-menu__bar gnav-menu__bar--2-2\" data-v-7fade5e0></div></a>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "gnav-list",
  key: "test"
}
const _hoisted_8 = { class: "gnav-item gnav-item--home" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "clip" }, "HOME"),
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt2" }, "HOME", -1))
const _hoisted_11 = { class: "gnav-item gnav-item--about" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "clip" }, "ABOUT"),
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt2" }, "ABOUT", -1))
const _hoisted_14 = { class: "gnav-item gnav-item--works" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "clip" }, "WORKS"),
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt2" }, "WORKS", -1))
const _hoisted_17 = { class: "gnav-item gnav-item--contact" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "clip" }, "CONTACT"),
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt2" }, "CONTACT", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal horizontal--1" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal horizontal--2" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical vertical--1" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical vertical--2" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical vertical--3" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["gnav-menu__btn", {'is--open': _ctx.open}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open=!_ctx.open))
      }, _hoisted_6, 2)
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open=!_ctx.open)),
                "exact-active-class": "is--current"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/about",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open=!_ctx.open)),
                "exact-active-class": "is--current"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: "/works/2021",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open=!_ctx.open)),
                "exact-active-class": "is--current"
              }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: "/contact",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open=!_ctx.open)),
                "exact-active-class": "is--current"
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _hoisted_19
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_20,
          _hoisted_21,
          _hoisted_22,
          _hoisted_23,
          _hoisted_24
        ], 512), [
          [_vShow, _ctx.open]
        ])
      ]),
      _: 1
    })
  ]))
}